export default __webpack_public_path__ + "static/media/close.67646c08.svg";